export const orderStatuses = [
  { value: "New", label: "New" },
  { value: "Direct Ship", label: "Direct Ship" },
  { value: "Coming To TMUSA", label: "Coming To US" },
  { value: "Shipping From Inventory", label: "Shipping From Inventory" },
  { value: "Shipped", label: "Shipped" },
  { value: "Partially Shipped", label: "Partially Shipped" },
  { value: "Hold", label: "Hold" },
  { value: "Backorder", label: "Backorder" },
  { value: "Customer Cancelled", label: "Customer Cancelled" },
  { value: "Vendor Cancelled", label: "Vendor Cancelled" },
  { value: "Delivered", label: "Delivered" },
  { value: "Completed", label: "Completed" },
];
export const paymentStatuses = [
  { value: "Pending Payment", label: "Pending Payment" },
  { value: "Paid", label: "Paid" },
  { value: "Pending Failed", label: "Pending Failed" },
  { value: "Refunded", label: "Refunded" },
  { value: "Authorized", label: "Authorized" },
  { value: "Failed", label: "Failed" },
];
export const returnStatuses = [
  { value: "Return Created", label: "Return Created" },
  { value: "Return Requested", label: "Return Requested" },
  { value: "Approved", label: "Approved" },
  { value: "Rejected", label: "Rejected" },
  { value: "Return Shipped", label: "Return Shipped" },
  { value: "Completed", label: "Completed" },
];
export const purchaseStatuses = [
  { value: "", label: "All" },
  { value: "draft", label: "Draft" },
  { value: "active", label: "Active" },
  { value: "cancel", label: "Cancelled" },
  { value: "pending cancellation", label: "Pending Cancellation" },
];
export const purchaseOrdersStatuses = [
  { value: "draft", label: "Draft" },
  { value: "active", label: "Active" },
  { value: "cancel", label: "Cancel" },
  { value: "pending cancellation", label: "Pending Cancellation" },
];
export const addressTypeOptions = [
  { value: "COMMERCIAL", label: "Commercial" },
  { value: "RESIDENTIAL", label: "Residential" },
];
export const signatureRequiredOptions = [
  { value: "INDIRECT", label: "INDIRECT" },
  { value: "DIRECT", label: "DIRECT" },
  { value: "ADULT", label: "ADULT" },
  { value: "RELEASE", label: "RELEASE" },
];
export const returnStatus = [

  {
    label: "Return Created",
    value: "Return Created",
  },
  {
    label: "Return Requested",
    value: "Return Requested",
  },
  {
    label: "Approved",
    value: "Approved",
  },
  {
    label: "Rejected",
    value: "Rejected",
  },
  {
    label: "Return shipped",
    value: "Return shipped",
  },
  {
    label: "Completed",
    value: "Completed",
  },
];
export const returnStatusShip = [
  {
    label: "Ground 5 - 7 Days",
    value: "Ground 5 - 7 Days",
  },
  {
    label: "2 Day Shipping",
    value: "2 Day Shipping",
  },
  {
    label: "Standard Overnight",
    value: "Standard Overnight",
  },
  {
    label: "Priority Overnight",
    value: "Priority Overnight",
  },
];
export const newItemSettings = [
  {
    value: "yes",
    label: "Yes",
  },
  {
    value: "no",
    label: "No",
  },
];
export const productTypes = [
  {
    value: "Hardware",
    label: "Hardware",
  },
  {
    value: "Software",
    label: "Software",
  },
];
export const newItemCondition = [
  { label: "New", value: "new" },
  { label: "Used", value: "used" },
  { label: "Open-Box", value: "open-box" },
  { label: "Refurbished", value: "refurbished" },
];
export const orderTerms = [
  {
    label: "Due on Receipt",
    value: "Due on Receipt",
  },
  {
    label: "Prepay (Check/ACH/Wire)",
    value: "Prepay (Check/ACH/Wire)",
  },
  {
    label: "Prepay (Credit Card)",
    value: "Prepay (Credit Card)",
  },
  {
    label: "Net 15",
    value: "Net 15",
  },
  {
    label: "Net 20",
    value: "Net 20",
  },
  {
    label: "Net 30",
    value: "Net 30",
  },
  {
    label: "Net 45",
    value: "Net 45",
  },
  {
    label: "Net 60",
    value: "Net 60",
  },
];
export const purchaseCompanies = [
  {
    label: "FEDEX",
    value: "FEDEX",
  },
  {
    label: "UPS",
    value: "UPS",
  },
  {
    label: "USPS",
    value: "USPS",
  },
  {
    label: "Others",
    value: "Others",
  },
];
export const purchaseShippings = [
  {
    label: "Ground 5 - 7 Days",
    value: "Ground 5 - 7 Days",
  },
  {
    label: "2 Day Shipping",
    value: "2 Day Shipping",
  },
  {
    label: "Standard Overnight",
    value: "Standard Overnight",
  },
  {
    label: "Priority Overnight",
    value: "Priority Overnight",
  },
];
export const upsServiceTypes = [
  {
    id: "01",
    name: "Next Day Air",
  },
  {
    id: "02",
    name: "2nd Day Air",
  },
  {
    id: "03",
    name: "Ground",
  },
  {
    id: "12",
    name: "3 Day Select",
  },
  {
    id: "13",
    name: "Next Day Air Saver",
  },
  {
    id: "14",
    name: "UPS Next Day Air Early",
  },
  {
    id: "59",
    name: "2nd Day Air A.M.",
  },
  {
    id: "75",
    name: "UPS Heavy Goods",
  },
];
export const statesArray = [
  { label: "Alabama", value: "AL", code: "AL" },
  { label: "Alaska", value: "AK", code: "AK" },
  { label: "Arizona", value: "AZ", code: "AZ" },
  { label: "Arkansas", value: "AR", code: "AR" },
  { label: "California", value: "CA", code: "CA" },
  { label: "Colorado", value: "CO", code: "CO" },
  { label: "Connecticut", value: "CT", code: "CT" },
  { label: "Delaware", value: "DE", code: "DE" },
  { label: "District of Columbia", value: "DC", code: "DC" },
  { label: "Florida", value: "FL", code: "FL" },
  { label: "Georgia", value: "GA", code: "GA" },
  { label: "Hawaii", value: "HI", code: "HI" },
  { label: "Idaho", value: "ID", code: "ID" },
  { label: "Illinois", value: "IL", code: "IL" },
  { label: "Indiana", value: "IN", code: "IN" },
  { label: "Iowa", value: "IA", code: "IA" },
  { label: "Kansas", value: "KS", code: "KS" },
  { label: "Kentucky", value: "KY", code: "KY" },
  { label: "Louisiana", value: "LA", code: "LA" },
  { label: "Maine", value: "ME", code: "ME" },
  { label: "Maryland", value: "MD", code: "MD" },
  { label: "Massachusetts", value: "MA", code: "MA" },
  { label: "Michigan", value: "MI", code: "MI" },
  { label: "Minnesota", value: "MN", code: "MN" },
  { label: "Mississippi", value: "MS", code: "MS" },
  { label: "Missouri", value: "MO", code: "MO" },
  { label: "Montana", value: "MT", code: "MT" },
  { label: "Nebraska", value: "NE", code: "NE" },
  { label: "Nevada", value: "NV", code: "NV" },
  { label: "New Hampshire", value: "NH", code: "NH" },
  { label: "New Jersey", value: "NJ", code: "NJ" },
  { label: "New Mexico", value: "NM", code: "NM" },
  { label: "New York", value: "NY", code: "NY" },
  { label: "North Carolina", value: "NC", code: "NC" },
  { label: "North Dakota", value: "ND", code: "ND" },
  { label: "Ohio", value: "OH", code: "OH" },
  { label: "Oklahoma", value: "OK", code: "OK" },
  { label: "Oregon", value: "OR", code: "OR" },
  { label: "Pennsylvania", value: "PA", code: "PA" },
  { label: "Rhode Island", value: "RI", code: "RI" },
  { label: "South Carolina", value: "SC", code: "SC" },
  { label: "South Dakota", value: "SD", code: "SD" },
  { label: "Tennessee", value: "TN", code: "TN" },
  { label: "Texas", value: "TX", code: "TX" },
  { label: "Utah", value: "UT", code: "UT" },
  { label: "Vermont", value: "VT", code: "VT" },
  { label: "Virginia", value: "VA", code: "VA" },
  { label: "Washington", value: "WA", code: "WA" },
  { label: "West Virginia", value: "WV", code: "WV" },
  { label: "Wisconsin", value: "WI", code: "WI" },
  { label: "Wyoming", value: "WY", code: "WY" },
  { label: "Other", value: "Other", code: "OT" }
];